export var EMessageRequestTypes = /*#__PURE__*/function (EMessageRequestTypes) {
  EMessageRequestTypes["getSubscription"] = "getSubscription";
  return EMessageRequestTypes;
}({});
export var EMessageResponseTypes = /*#__PURE__*/function (EMessageResponseTypes) {
  EMessageResponseTypes["subscriptionStatus"] = "subscriptionStatus";
  EMessageResponseTypes["workerRegistred"] = "workerRegistred";
  return EMessageResponseTypes;
}({});
export var EWindowStaticMethods = /*#__PURE__*/function (EWindowStaticMethods) {
  EWindowStaticMethods["ready"] = "__push_manager_ready__";
  EWindowStaticMethods["checkSubsciption"] = "__push_manager_check_subscription__";
  return EWindowStaticMethods;
}({});